export function isEmptyContent(content) {
  if (Array.isArray(content)) {
    return content.length === 0;
  }

  if (typeof content === "object" && content !== null) {
    return Object.keys(content).length === 0;
  }

  if (typeof content === "string") {
    return content.trim() === "";
  }

  if (content === null || content === undefined) {
    return true;
  }
  return false;
}
